import { bootWebContainer, waitForTemplateReady } from './index';
import { workbenchStore } from '../stores/workbench';

export type PrewarmOptions = {
  signal?: AbortSignal;
};

/**
 * Boot WebContainer + mount template during browser idle time.
 * Shares the global singleton — later real boots are cache hits.
 */
export async function prewarmWorkbench(opts?: PrewarmOptions): Promise<void> {
  if (typeof window === 'undefined' || !window.crossOriginIsolated) {
    workbenchStore.prewarmState.set('skipped');
    return;
  }
  if (opts?.signal?.aborted) {
    workbenchStore.prewarmState.set('skipped');
    return;
  }

  workbenchStore.prewarmState.set('running');
  try {
    await bootWebContainer();
    if (opts?.signal?.aborted) {
      workbenchStore.prewarmState.set('skipped');
      return;
    }
    await waitForTemplateReady();
    workbenchStore.prewarmState.set('ready');
  } catch (err) {
    console.warn('[Workbench] prewarm failed', err);
    workbenchStore.prewarmState.set('failed');
  }
}

export function shouldSchedulePrewarm(): boolean {
  if (typeof window === 'undefined' || !window.crossOriginIsolated) return false;

  const envFlag = import.meta.env?.VITE_WORKBENCH_PREWARM;
  if (envFlag === '0' || envFlag === 'false') return false;

  const conn = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } })
    .connection;
  if (conn?.saveData) return false;
  if (conn?.effectiveType === 'slow-2g' || conn?.effectiveType === '2g') return false;

  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  if (memory != null && memory < 4) return false;

  return true;
}
